// extracted by mini-css-extract-plugin
export const loader = "BigLoader-module--loader--3FQOn";